import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2,
    Minus,
    CircleMinus,
    CirclePlus,
    Palette,
    AlignEndVertical,
    AlignStartVertical,
    AlignStartHorizontal,
    AlignEndHorizontal,
    BetweenHorizonalEnd,
    BetweenHorizontalStart,
    BetweenVerticalStart} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import HighlightsQuiz from "./HighlightsQuiz";
import FAQsQuiz from "./FAQsQuiz";
import RangeSlider from "../../../UI/RangeSlider";
import AppearanceToggleCard from "../../../UI/AppearanceToggleCard";
import ColorPicker from "../../../UI/ColorPicker/Colorpicker";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const TestDesignSettings= ({quizObjectID,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 

           const [testInterfaceTheme, setTestInterfaceTheme] = useState();
           
           const changeTestTheme = ( theme) => {
            
            handleCreateNewMockTest("testInterfaceTheme",theme);
        
        };
     const colorPickerOptionArray =[     
                                     'rgba(255, 114, 94, 1)',      
                                 'rgba(255, 114, 94, 0.5)', 
                                      
                               'rgba(255, 255, 255, 0.9)',    
                                 'rgba(255, 114, 94, 0.1)'      
                                 , 'rgba(55, 71, 79, 1)',       
                                 'rgba(255, 193, 0, 1)'  ];
                         
                         
                                 const [activeColorPickerValue,setActiveColorPickerValue]=useState('#99cc99')
                                 const [themeColor ,setThemeColor] =useState({
                                   primaryColor:'rgba(255, 204, 153,1)',
                                    primaryColorOpacity5:'rgba(255, 204, 153,0.5)', 
                                   buttonColor:'rgba(255, 204, 153,0.9)',
                                   iconColorInfo:'rgba(83, 89, 103,0.9)', 
                                    activityColor:'rgba(255, 204, 153,0.1)'});
                         
      const [goNextPopUp, setGoNextPopUp] =useState(false);
     
     const [activeStep, setActiveStep] = useState(0);
     const [activeSubStepOne, setActiveSubStepOne] = useState(3);
     
     const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
     const [activeSubStepThree, setActiveSubStepThree] = useState(0);
     const [activeSubStepFour, setActiveSubStepFour] = useState(0);
     const [activeSubStepFive, setActiveSubStepFive] = useState(0);
     const [titleActive, setTitleActive] = useState(true);
     const [desctiptionActive, setDesctiptionActive] = useState(false);
     const [highlightActive, setHighlightActive] = useState(false);
     const [FAQActive, setFAQActive] = useState(false);
    
    const steps = ([{number:1,name:"Theme & Color"},{number:2,name:"Pallet/Pagenation "}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizName, setQuizName] = useState("");
        const [reAttempts,  setReAttempts] = useState("");
        const [higlights,  setHiglights] = useState([]);
        const [FAQs,  setFAQs] = useState([]);
        
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({});
   
        const [totalNo, setTotalNo] = useState(80);
        const [allowUserNotes, setAllowUserNotes] = useState();
        const [allowTestRatings, setAllowTestRatings] = useState();
        const [allowTestReview, setAllowTestReview] = useState();
        const [showCalci, setShowCalci] = useState();
        const [autoSubmitMode, setAutoSubmitMode] = useState();
        const [lockSubmitButton, setLockSubmitButton] = useState();
        const [ rangeSliderVisible, setRangeSliderVisible] = useState(false);
        const [ testDesignValue, setTestDesignValue] = useState("");
        const [ palletDirection, setPalletDirection] = useState("");
        const [ pagenationDirection, setPagenationDirection] = useState("");
        
   const changeTestPalletOrPage = ( value) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
    setTestDesignValue(value);
            handleCreateNewMockTest("testPalletOrPage",value)
   };
   const changePalletDirection = ( value) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
    setPalletDirection(value);
            handleCreateNewMockTest("palletDirection",value)
   }; const changePagenationDirection = ( value) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
    setPagenationDirection(value);
            handleCreateNewMockTest("pagenationDirection",value)
   };
    const userdata = useSelector((state)=>state?.user?.user);
   useEffect(()=>{
   
   fireGetQuizDataByQuizId()
   
   },[])
   useEffect(()=>{
   
    setAnimate(false);  
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 1000);
 
    return () => clearTimeout(timer); 
    },[titleActive,desctiptionActive,highlightActive,FAQActive])
   const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:quizName,type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      setQuizObject(response?.quiz)
      setTestInterfaceTheme(response?.quiz?.testInterfaceTheme);
      setActiveColorPickerValue(response?.quiz?.testInterfaceColor?JSON.parse(response?.quiz?.testInterfaceColor):null);
      setTestDesignValue(response?.quiz?.testPalletOrPage);
      setPalletDirection(response?.quiz?.palletDirection);
      setPagenationDirection(response?.quiz?.pagenationDirection);
      setLoader({status:false});
      setRangeSliderVisible(true)
  
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
     const handleCreateNewMockTest=(editType,val)=>{
     let SendObject=""
     if(editType=="testInterfaceTheme"){
        SendObject={testInterfaceTheme:val,type:"mock",
            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="testInterfaceColor"){
                SendObject={testInterfaceColor:val,type:"mock",
                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                    currentToken:currentToken?currentToken:"",
                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                     }
                     if(editType=="testPalletOrPage"){
                        SendObject={testPalletOrPage:val,type:"mock",
                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                            currentToken:currentToken?currentToken:"",
                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                             }
                             
                             if(editType=="palletDirection"){
                                SendObject={palletDirection:val,type:"mock",
                                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                    currentToken:currentToken?currentToken:"",
                                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                     }
                                     if(editType=="pagenationDirection"){
                                        SendObject={pagenationDirection:val,type:"mock",
                                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                            currentToken:currentToken?currentToken:"",
                                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                             }
                                             
                                     
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest(SendObject));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
           if(response?.quiz){
            if(editType!="durationValue"){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
      setSnackbarVisible(true);
              }
       setQuizObject(response?.quiz)
       setTestInterfaceTheme(response?.quiz?.testInterfaceTheme);
      //  setActiveColorPickerValue(response?.quiz?.testInterfaceColor);
        setActiveColorPickerValue(response?.quiz?.testInterfaceColor?JSON.parse(response?.quiz?.testInterfaceColor):null);
       setTestDesignValue(response?.quiz?.testPalletOrPage);
       setPalletDirection(response?.quiz?.palletDirection);
       setPagenationDirection(response?.quiz?.pagenationDirection);
    
      
      setQuizObjectDataBack(response?.quiz)
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
       if(editType=="testInterfaceColor"){
       setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0); }
        if(editType=="cutOffPercent"){
      
            setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
         
            } if(editType=="higlights"){
      
                setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
                setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
              
                }
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
      


       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
       <div   className=" progress-bar-container "style={{position:"relative",zIndex:"99"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){ setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==2){  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==3){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
          }else if(step?.number==4){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>
      <div  className=""style={{marginTop:"40px"}}><div  className=" " style={{background:"#fff",borderRadius:"25px",paddingBottom:"50px"}}>

 {titleActive?
    <div>
    <div  className="ikcraft_login-input-card" style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(10px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}>
    <h2 style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}> Select A Theme For Your  <span className="coloredTextV1" > Test. </span></h2>
       <div> 
         <div className="gridForWhatsNextAfterYT5" style={{background:"#ffffff",borderRadius:"25px",margin:"5px",paddingBottom:"0px"}}> 
       <div >  <h2 style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   Set  <span className="coloredTextV1" > Test Theme </span>  </h2>
           <div style={{height:"90px"}}> 
            <div class="input-card-outer"style={{
                  transform: animate ? 'translateY(0)' : 'translateY(10px)',
                  opacity: animate ? 1 : 0.8,
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div class=" gridFiftyFixed">
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} ><div style={{position:"relative"}}>CBT</div> <NotepadText onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> </div>  
                              <input type="radio" title="Set As Years"   checked={testInterfaceTheme=="CBT"?"yes":""}
                   className="input-textbox"  value="CBT"  name="courseExpiryType1"  
                   onClick={e=>{changeTestTheme(e.target.value);;setTestInterfaceTheme(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} ><div style={{position:"relative"}}>Color Theme</div> <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> </div> 
                              <input type="radio" title="Color Theme"   checked={testInterfaceTheme=="colorTheme1"?"yes":""}
                   className="input-textbox"  value="colorTheme1"  name="courseExpiryType1"  
                   onChange={e=>{changeTestTheme(e.target.value);;setTestInterfaceTheme(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label> 
                        </div>  </div></div> </div>
            <div  style={{"textAlign":"center",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>    {testInterfaceTheme=="colorTheme1"?<div style={{display:"flex",justifyContent:"center",marginTop:"15px",}}>
{/* <ColorPicker activeColorPickerValue={activeColorPickerValue?activeColorPickerValue:"#99cc99"} setActiveColorPickerValue={(color)=>{
setActiveColorPickerValue(color);handleCreateNewMockTest("testInterfaceColor",color)}} colorPickerOptionArray={colorPickerOptionArray} />  */}

<ColorPickerDynamic activeColorPickerValue={activeColorPickerValue?activeColorPickerValue?.colorScheme?.color:"#99cc99"} setActiveColorPickerValue={(color)=>{
setActiveColorPickerValue({theme:"One",colorScheme:color}); }} palletTitle={"Set Test Theme Color"} colorPickerOptionArray={[]} /> 

<div  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{width:"100px",cursor:"pointer",marginLeft:"5px",display:"flex",justifyContent:"center",alignItems:"center",padding:"10px 10px",border:"3px solid rgba(144, 202, 249,1)",background:activeColorPickerValue?.colorScheme?.color?activeColorPickerValue?.colorScheme?.color:"#99cc99",borderRadius:"10px",fontSize:"18px",fontWeight:"800",color:"#fff"}}
       onClick={()=>{ handleCreateNewMockTest("testInterfaceColor",JSON.stringify(activeColorPickerValue))}}>Save Color</div>
</div>:""}   </div>                   
                                                    </div>

                                                   
</div></div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><div></div>
   {testInterfaceTheme=="CBT"||testInterfaceTheme==""? <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
      }}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>:""}
    </div>
    </div> </div>:""}
   
{desctiptionActive?
   <div>
   <div  className="ikcraft_login-input-card">
   <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-20px)',
        opacity: animate ? 1 : 0.5,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Test Button  <span className="coloredTextV1" > Appearance </span></h2>
      
      <div className="gridForWhatsNextAfterYT2" style={{background:"#ffffff",borderRadius:"25px",margin:"5px",paddingBottom:"0px"}}> 
    <div>
    <h2 style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   Set  <span className="coloredTextV1" > Test Button Appearance</span>  </h2>
            </div> 
      <div > 
           <div style={{height:"90px"}}> 
            <div class="input-card-outer"style={{
                  transform: animate ? 'translateY(0)' : 'translateY(10px)',
                  opacity: animate ? 1 : 0.8,
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div class=" gridFiftyFixed">
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} ><BetweenHorizonalEnd onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Pallet</div> </div> 
      
                              <input type="radio" title="Set As Years"   checked={testDesignValue=="pallet"?"yes":""}
                   className="input-textbox"  value="pallet"  name="courseExpiryType1"  
                   onClick={e=>{changeTestPalletOrPage(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} ><BetweenVerticalStart onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Pagenation</div> </div> 
      
                              <input type="radio" title="Color Theme"   checked={testDesignValue=="pagenation"?"yes":""}
                   className="input-textbox"  value="pagenation"  name="courseExpiryType1"  
                   onChange={e=>{changeTestPalletOrPage(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label> 
                        </div>  </div></div> </div> </div>
                        
                        {testDesignValue=="pallet"?<div className="gridForWhatsNextAfterYT2" style={{background:"#ffffff",borderRadius:"25px",margin:"5px",paddingBottom:"0px"}}> 
    <div>
    <h3 style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   Set  <span className="coloredTextV1" > Test Pallet  Appearance</span>  </h3>
            </div> 
      <div > 
           <div style={{height:"90px"}}> 
            <div class="input-card-outer"style={{
                  transform: animate ? 'translateY(0)' : 'translateY(10px)',
                  opacity: animate ? 1 : 0.8,
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div class=" gridFiftyFixed">
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} > <AlignStartVertical onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Left Pallet</div></div> 
                              <input type="radio" title="Set As Years"   checked={palletDirection=="left"?"yes":""}
                   className="input-textbox"  value="left"  name="palletDirection"  
                   onClick={e=>{changePalletDirection(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                           <div style={{display:"flex",justifyContent:"space-between"}} ><AlignEndVertical onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Right Pallet</div> </div> 
      
                              <input type="radio" title="Color Theme"   checked={palletDirection=="right"?"yes":""}
                   className="input-textbox"  value="right"  name="palletDirection"  
                   onChange={e=>{changePalletDirection(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label> 
                        </div>  </div></div> </div> </div>:""}
                        
                        {testDesignValue=="pagenation"?<div className="gridForWhatsNextAfterYT2" style={{background:"#ffffff",borderRadius:"25px",margin:"5px",paddingBottom:"0px"}}> 
    <div>
    <h3 style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   Set  <span className="coloredTextV1" > Test Pagenation  Appearance</span>  </h3>
            </div> 
      <div > 
           <div style={{height:"90px"}}> 
            <div class="input-card-outer"style={{
                  transform: animate ? 'translateY(0)' : 'translateY(10px)',
                  opacity: animate ? 1 : 0.8,
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div class=" gridFiftyFixed">
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} ><AlignStartHorizontal onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Top Pagenation</div> </div> 
      
                              <input type="radio" title="Set As Years"   checked={pagenationDirection=="top"?"yes":""}
                   className="input-textbox"  value="top"  name="pagenationDirection"  
                   onClick={e=>{changePagenationDirection(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                         <div style={{display:"flex",justifyContent:"space-between"}} ><AlignEndHorizontal onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/> <div style={{position:"relative"}}>Bottom Pagenation</div> </div> 
      
                              <input type="radio" title="Color Theme"   checked={pagenationDirection=="bottom"?"yes":""}
                   className="input-textbox"  value="bottom"  name="pagenationDirection"  
                   onChange={e=>{changePagenationDirection(e.target.value);;}}/>
                        <span class={"boxCardBorder"}></span> </label> 
                        </div>  </div></div> </div> </div>:""}
                        
                        
                         </div>


                        
    <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
       <div  >   </div>
     
       <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
      
      transition: 'transform 2s ease, opacity 1s ease',
    }}><button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
      setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);}}   className=" CoursesPreviewTopBtn"  type="submit"
   > Back </button>
   <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{ 
    
     }}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
     className=" CoursesPreviewTopBtn"  type="submit"
    > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
   </div>
   </div> </div> 
 :""}
  {highlightActive? <div>
    <div  className="ikcraft_login-input-card"  style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>
          
      
      
          <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Take Notes During And After Test. "} </h4></div>
            <Toggle state={allowUserNotes} toggleState={(state)=>{setAllowUserNotes(state) ;handleCreateNewMockTest("allowUserNotes",state)}} />
               </div> 
             
               <div className="gridForWhatsNextAfterYT2"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}>
      
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Rate The Test. "} </h4></div>
            <Toggle state={allowTestRatings} toggleState={(state)=>{setAllowTestRatings(state) ;handleCreateNewMockTest("allowTestRatings",state)}} />
               </div> 
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Write A Test Review.   "} </h4></div>
            <Toggle state={allowTestReview} toggleState={(state)=>{setAllowTestReview(state) ;handleCreateNewMockTest("allowTestReview",state)}} />
               </div> 
               
      </div>  
      </div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
       setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
     }}   className=" CoursesPreviewTopBtn"  type="submit"
    > Back </button>
    <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{ setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
     }}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>
    </div>
    </div> </div>:""}
 
{FAQActive? <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Test  <span className="coloredTextV1" > Settings </span></h2>
      
      <div className="gridForWhatsNextAfterYT2"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h2 style={{paddingTop:"30px"}}>Allow Calculator During The Test  </h2></div>
            <AppearanceToggleCard animEffect={200} handleCourseSettings={(state)=>handleCreateNewMockTest("showCalci",state)} myCardState={showCalci} setMyCardState={setShowCalci} progress={35} icon={3}  title="Show Calculator"  cursorAlign="" cursorTextVal=""/>
            </div> 

            <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Once Enabled Test Will Be Automitically Submitted when Timer Ends "} </h4></div>
            <Toggle state={autoSubmitMode} toggleState={(state)=>{setAutoSubmitMode(state) ;handleCreateNewMockTest("autoSubmitMode",state)}} />
               </div> 
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Once Enabled Users Can't Submit Test Manually Until Timer Ends "} </h4></div>
            <Toggle state={lockSubmitButton} toggleState={(state)=>{setLockSubmitButton(state) ;handleCreateNewMockTest("lockSubmitButton",state)}} />
               </div> 

 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{   setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
    
  }}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Next"} </button>
</div>
</div> </div>
 :""} 
    
 <div>
     </div>
    
    </div>
    </div>
     </>


}
export default TestDesignSettings;